import React from 'react';
import BaseCell from './BaseCell';

const EmailCell = ({ email, ...props }) => (
  <BaseCell {...props} selectable={false}>
    <a href={`mailto:${email}`}>{email}</a>
  </BaseCell>
);

export default EmailCell;
